<template>
  <app-user v-slot="{ isServiceProvider, isCustomer, isClient }">
    <service-provider-actions v-if="isServiceProvider" :account="account" />
    <customer-actions v-if="isCustomer" :account="account" />
    <client-actions v-if="isClient" :account="account" />
  </app-user>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AppUser from '@/auth/AppUser.vue';
import { Account } from '@/social/types';
import ClientActions from './ClientActions.vue';
import CustomerActions from './CustomerActions.vue';
import ServiceProviderActions from './ServiceProviderActions.vue';

export default defineComponent({
  components: {
    AppUser,
    ServiceProviderActions,
    CustomerActions,
    ClientActions,
  },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
});
</script>
